// Links and names for a code at the signed-in location: its booking link
// (the salon's page, or the stylist's own for theirs) and whose it is.
import siteSetting from '../../config/env';
import { codeLink } from './data/codes';

const storedHairdresser = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user')) || null;
    return (u && (u.hairdresser || (u.userInfo && u.userInfo.hairdresser))) || {};
  } catch (e) { return {}; }
};

// `src` marks where the link was shared (qr, email, sms, social) so
// Performance can say which one brought the booking
export const linkFor = (code, src) => {
  const hd = storedHairdresser();
  const salon = hd.salon || {};
  return codeLink({
    web: siteSetting && siteSetting.api && siteSetting.api.weburl,
    salonSlug: salon.slug || salon._id || localStorage.getItem('salonId'),
    stylistId: code && code.ownerType === 'stylist' ? code.ownerId : null,
    code: code && code.code,
    src,
  });
};

export const businessName = (code) => {
  const hd = storedHairdresser();
  let u = {};
  try { u = JSON.parse(localStorage.getItem('user')) || {}; } catch (e) { u = {}; }
  if (code && code.ownerType === 'stylist') return code.ownerName || u.name || '';
  return (hd.salon && hd.salon.salonName) || '';
};
